import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { FontSizeInPx, FontWeight, Spacing } from "@snapchat/snap-design-system";

export const CreatorLink = styled.div`
    > .ant-btn.sds-button {
        min-height: 24px;
        padding: 0;

        font-size: ${FontSizeInPx}px;
        font-weight: ${FontWeight.MEDIUM};
        vertical-align: baseline;
    }
`;

export const ExitSection = styled.div`
    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: center;

    width: 28px;
    height: 38px;
`;

export const AccountName = styled.p`
    width: 135px;
    margin-bottom: 0;

    font-size: ${FontSizeInPx.COMPACT}px;
    font-weight: ${FontWeight.MEDIUM};
    font-style: normal;
`;

export const ContentInfo = css`
    padding: 0 8px 0 10px;
`;

export const popoverStyleWithPadding = css`
    & .ant-popover-inner-content {
        padding: ${Spacing.XS}px ${Spacing.SM}px;
    }
`;
